<!--Vista BI-->

<!-- Vista Capacitaciones-->
<div *ngIf="flagCapacitaciones" class="capacitaciones-page">
  <div class="filters" *ngIf="actualView == 'table'">
    <nav class="navbar navbar-expand-md navbar-light">
      <button class="navbar-toggler d-lg-none buttonNav" type="button" (click)="isCollapsed = !isIndicatorsCollapsed"
        [attr.aria-expanded]="!isIndicatorsCollapsed" aria-controls="navbarsExampleDefault"
        aria-label="Toggle navigation">
        <label>Menú</label>
      </button>
      <div class="collapse navbar-collapse" id="navbarsExampleDefault" [ngbCollapse]="!isIndicatorsCollapsed">
        <ul class="navbar-nav mr-auto">
          <!-- <li class="nav-item">
            <div ngbDropdown class="filter-dropdown">
              <button class="btn toggle-button" id="zona" ngbDropdownToggle>Zona</button>
              <div ngbDropdownMenu aria-labelledby="zona">
                <button (click)="filterZone('')" ngbDropdownItem class="item-button">Seleccionar
                  Todo</button>
                <button *ngFor="let zona of zonas" (click)="filterZone(zona.zoneId)" ngbDropdownItem
                  class="item-button">{{zona.nombreContratista}}</button>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <div *ngIf="rolid == 1" ngbDropdown class="filter-dropdown">
              <button class="btn toggle-button" id="empresa" ngbDropdownToggle>Empresa</button>
              <div ngbDropdownMenu aria-labelledby="empresa">
                <button ngbDropdownItem class="item-button">Seleccionar Todo</button>
                <button *ngFor="let empresa of empresas" (click)="filterEnterprise(empresa.nombreContratista)"
                  ngbDropdownItem class="item-button">{{empresa.nombreContratista}}</button>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <div *ngIf="rolid != 3" ngbDropdown class="filter-dropdown">
              <button class="btn toggle-button" id="contratista" ngbDropdownToggle>Contratista</button>
              <div ngbDropdownMenu aria-labelledby="contratista">
                <button ngbDropdownItem class="item-button">Seleccionar Todo</button>
                <button *ngFor="let contratista of contratistas"
                  (click)="filterContratista(contratista.nombreTrabajador)" ngbDropdownItem
                  class="item-button">{{contratista.nombreTrabajador}} {{contratista.apellidoPaterno}}</button>
              </div>
            </div>
          </li> -->
          <!-- <li class="nav-item">
            <div ngbDropdown class="filter-dropdown">
              <button class="btn toggle-button" id="año" ngbDropdownToggle>{{"Año " + filterAno}}</button>
              <div ngbDropdownMenu aria-labelledby="año">
                <button (click)="filterYear('')" ngbDropdownItem class="item-button">Seleccionar Todo</button>
                <button (click)="filterYear(yr)" *ngFor="let yr of generateArrayOfYears()" ngbDropdownItem
                  class="item-button">{{yr}}</button>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <div ngbDropdown class="filter-dropdown">
              <button class="btn toggle-button" id="mes" ngbDropdownToggle>{{"Mes " + filterMes}}</button>
              <div ngbDropdownMenu aria-labelledby="año">
                <button (click)="filterMonth('')" ngbDropdownItem class="item-button">Seleccionar Todo</button>
                <button (click)="filterMonth('01')" ngbDropdownItem class="item-button">Enero</button>
                <button (click)="filterMonth('02')" ngbDropdownItem class="item-button">Febrero</button>
                <button (click)="filterMonth('03')" ngbDropdownItem class="item-button">Marzo</button>
                <button (click)="filterMonth('04')" ngbDropdownItem class="item-button">Abril</button>
                <button (click)="filterMonth('05')" ngbDropdownItem class="item-button">Mayo</button>
                <button (click)="filterMonth('06')" ngbDropdownItem class="item-button">Junio</button>
                <button (click)="filterMonth('07')" ngbDropdownItem class="item-button">Julio</button>
                <button (click)="filterMonth('08')" ngbDropdownItem class="item-button">Agosto</button>
                <button (click)="filterMonth('09')" ngbDropdownItem class="item-button">Septiembre</button>
                <button (click)="filterMonth('10')" ngbDropdownItem class="item-button">Octubre</button>
                <button (click)="filterMonth('11')" ngbDropdownItem class="item-button">Noviembre</button>
                <button (click)="filterMonth('12')" ngbDropdownItem class="item-button">Diciembre</button>
              </div>
            </div>
          </li> -->
        </ul>
      </div>
    </nav>
  </div>

  <div class="view-section">
    <div class="view-buttons">
      <button type="button" [class]="'btn shadow-none' + (actualView == 'calendar' ? ' button-selected' : '')"
        (click)="changeView('calendar')">
        <img [src]="actualView == 'calendar' ? 'assets/icons/calendar_white.svg' : 'assets/icons/calendar_black.svg'">
        Meses
      </button>
      <button type="button" [class]="'btn shadow-none' + (actualView == 'table' ? ' button-selected' : '')"
        (click)="changeView('table')">
        <img [src]="actualView == 'table' ? 'assets/icons/table_white.svg' : 'assets/icons/table_black.svg'"
          style="max-width: 24px;"> Tabla
      </button>
    </div>
    <div class="separation-line"></div>
    <app-calendar-view *ngIf="actualView == 'calendar'"></app-calendar-view>
    <app-table-view *ngIf="actualView == 'table'" [searchText]="searchText"></app-table-view>
  </div>
</div>
